import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { RandomStringGenerator } from "noood/util/rand/RandomStringGenerator";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
import Text from "noood/comp/text/Text";
export default function PickTimePopUp(props) {
  var _useState = useState(function () {
      if (props.value) {
        // parse and get the hour
        return Number(props.value.substring(0, props.value.indexOf(":")));
      } else return undefined;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    hour = _useState2[0],
    setHour = _useState2[1];
  var _useState3 = useState(function () {
      if (props.value) {
        // parse, get the hour
        var substring = props.value.substring(props.value.indexOf(":") + 1, props.value.indexOf(" "));
        console.log("substring is: ", substring);
        return Number(substring);
      } else return 0;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    minute = _useState4[0],
    setMinute = _useState4[1];
  var _useState5 = useState(function () {
      var _props$value$split;
      return props.value ? (_props$value$split = props.value.split(" ")) === null || _props$value$split === void 0 || (_props$value$split = _props$value$split[1]) === null || _props$value$split === void 0 ? void 0 : _props$value$split.toLowerCase() : "am";
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    amPm = _useState6[0],
    setAmPm = _useState6[1];
  var thisBodyRef = useRef();
  var id = RandomStringGenerator.alphanum(10);
  useEffect(function () {
    if (thisBodyRef.current && thisBodyRef.current.style.opacity === "") {
      var _props$sender;
      var floater = thisBodyRef.current;
      floater.style.opacity = "0";
      floater.showPopover(); // so that we can get the dimensions
      var anchor = (_props$sender = props.sender) === null || _props$sender === void 0 ? void 0 : _props$sender.getBoundingClientRect();
      var floaterDimensions = floater.getBoundingClientRect();
      console.log("floaterDimensions: ", floaterDimensions);
      console.log("anchor: ", anchor);
      console.log("window: ", window.scrollY);
      if (floater) {
        if (anchor.bottom + floaterDimensions.height + 30 > window.innerHeight) {
          floater.style.top = "".concat(anchor.top - floaterDimensions.height - 3, "px");
        } else {
          floater.style.top = "".concat(anchor.bottom + 3, "px");
        }
        if (anchor.right + floaterDimensions.width + 30 > window.innerWidth) {
          // move to the left because clipped in the right section
          floater.style.left = "".concat(anchor.left + anchor.width - floaterDimensions.width, "px");
        } else {
          floater.style.left = "".concat(anchor.left, "px");
        }
        floater.style.transition = 'opacity 0.1s';
        floater.style.opacity = "1";
      } else {
        alert('s');
      }
      floater.addEventListener('beforetoggle', function (e) {
        if (e.newState === 'closed') {
          var _props$contextSetter;
          (_props$contextSetter = props.contextSetter) === null || _props$contextSetter === void 0 || _props$contextSetter.call(props, undefined);
        }
      });
    }
  }, [thisBodyRef.current]);
  var __shoudClose = function __shoudClose(HH, MM, AMPM) {
    if (HH !== void 0 && MM !== void 0 && AMPM !== void 0) {
      var _props$_collect;
      var as24Hour = HH;
      if (AMPM === 'pm') {
        as24Hour = HH === 12 ? 12 : HH + 12;
      } else {
        as24Hour = HH === 12 ? 0 : HH;
      }
      var finalHour = ('0' + as24Hour.toString()).split("").splice(-2).join("");
      var final12Hour = ('0' + HH.toString()).split('').splice(-2).join('');
      var finalMinutes = ('0' + MM.toString()).split("").splice(-2).join("");
      // props.contextSetter?.(undefined);
      (_props$_collect = props._collect) === null || _props$_collect === void 0 || _props$_collect.call(props, final12Hour + ':' + finalMinutes + ' ' + AMPM.toLowerCase());
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: thisBodyRef,
    popover: '',
    id: id
  }, {
    className: "PickTimePopUp__ui.floater ev11ycvst evixxii4 evxwrc4x ev1i43fwc evh3736h ev1717udv ev1oza3rt evr540pp evegw5ml ev1q3khb0 evb6twbt"
  }), /*#__PURE__*/React.createElement(Row, {
    verticalAlign: "flex-start"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "5px"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 13
  }, "Hour"), /*#__PURE__*/React.createElement("div", {
    className: "PickTimePopUp__ui.hours_container evrvj5dj ev17e5z5g evl501l6"
  }, Array(12).fill(0).map(function (val, idx) {
    // 12 01 02 03 04 05 06 07 08 09 10 11
    var raw = 12 - (12 - idx);
    var h = raw === 0 ? 12 : raw;
    return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.hour, ui.aka_cell, hour === h && ui.active), {
      onClick: function onClick() {
        setHour(h);
        __shoudClose(h, minute, amPm);
      }
    }), '0'.concat(h.toString()).split("").splice(-2));
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "5px"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 13
  }, "Minute"), /*#__PURE__*/React.createElement("div", {
    className: "PickTimePopUp__ui.minutes_container evrvj5dj ev17e5z5g evl501l6"
  }, Array(12).fill(0).map(function (val, idx) {
    var _$concat;
    var m = idx * 5;
    return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.minutes, ui.aka_cell, m === minute && ui.active), {
      onClick: function onClick() {
        setMinute(m);
        __shoudClose(hour, m, amPm);
      }
    }), (_$concat = '0'.concat(m)) === null || _$concat === void 0 ? void 0 : _$concat.toString().split("").splice(-2));
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "5px"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 13
  }, "\xA0"), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.am_pm, amPm === 'am' && ui.active), {
    onClick: function onClick() {
      setAmPm('am');
      __shoudClose(hour, minute, 'am');
    }
  }), "AM"), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.am_pm, amPm === 'pm' && ui.active), {
    onClick: function onClick() {
      setAmPm('pm');
      __shoudClose(hour, minute, 'pm');
    }
  }), "PM"))));
}

// @ts-ignore
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".evixxii4{position:fixed}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1i43fwc{box-shadow:0 15px 35px rgba(0,0,0,.3)}", 3000);
_inject(".evh3736h{inset:unset}", 1000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".ev1oza3rt{border:1px solid light-dark(#aaa,var(--shade-light))}", 1000);
_inject(".evr540pp{z-index:100000000}", 3000);
_inject("@media (max-width: 599px){.evegw5ml.evegw5ml{position:fixed}}", 3200);
_inject("@media (max-width: 599px){.ev1q3khb0.ev1q3khb0{top:0}}", 4200);
_inject("@media (max-width: 599px){.evb6twbt.evb6twbt{right:0}}", 4200);
_inject(".evrvj5dj{display:grid}", 3000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".evl501l6{grid-template-columns:repeat(4,1fr)}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev9ms5i6{padding:3px}", 1000);
_inject(".ev1pg6f65{border:1px solid var(--shade-30)}", 1000);
_inject(".evwqakj{border-left:0}", 2000);
_inject(".evaqea5y{border-bottom:0}", 2000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev1dfczft:hover{background-color:var(--shade-05)}", 3130);
_inject(".evfge0gx:active{background-color:var(--shade-10)}", 3170);
_inject(".ev2qlj0z:first-of-type{border-left:1px solid var(--shade-30)}", 2053);
_inject(".ev2kl6on:first-of-type{border-top-left-radius:5px}", 4053);
_inject(".ev65r1ak:nth-child(4n+1){border-left:1px solid var(--shade-30)}", 2060);
_inject(".evdzo6gw:nth-child(4){border-top-right-radius:5px}", 4060);
_inject(".ev1qmgjwk:nth-child(n + 9){border-bottom:1px solid var(--shade-30)}", 2060);
_inject(".ev1vhxsb0:nth-child(9){border-bottom-left-radius:5px}", 4060);
_inject(".ev1gy14w1:nth-child(12){border-bottom-right-radius:5px}", 4060);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".evtv0qo8{border:1px solid var(--shade-10)}", 1000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".ev15hiw4d:first-of-type{border-top-right-radius:5px}", 4053);
_inject(".ev1mrc810:first-of-type{border-bottom:0}", 2053);
_inject(".evus5cz4:last-of-type{border-bottom-left-radius:5px}", 4055);
_inject(".ev16i8jsc:last-of-type{border-bottom-right-radius:5px}", 4055);
var ui = {
  aka_cell: {
    "PickTimePopUp__ui.aka_cell": "PickTimePopUp__ui.aka_cell",
    cursor: "ev1ypdohk",
    padding: "ev9ms5i6",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    border: "ev1pg6f65",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderLeft: "evwqakj",
    borderBottom: "evaqea5y",
    backgroundColor: "evjbqb8w ev1dfczft evfge0gx",
    ":first-of-type_borderLeft": "ev2qlj0z",
    ":first-of-type_borderLeftWidth": null,
    ":first-of-type_borderInlineStartWidth": null,
    ":first-of-type_borderInlineEndWidth": null,
    ":first-of-type_borderLeftStyle": null,
    ":first-of-type_borderInlineStartStyle": null,
    ":first-of-type_borderInlineEndStyle": null,
    ":first-of-type_borderLeftColor": null,
    ":first-of-type_borderInlineStartColor": null,
    ":first-of-type_borderInlineEndColor": null,
    ":first-of-type_borderTopLeftRadius": "ev2kl6on",
    ":first-of-type_borderStartStartRadius": null,
    ":first-of-type_borderStartEndRadius": null,
    ":nth-child(4n+1)_borderLeft": "ev65r1ak",
    ":nth-child(4n+1)_borderLeftWidth": null,
    ":nth-child(4n+1)_borderInlineStartWidth": null,
    ":nth-child(4n+1)_borderInlineEndWidth": null,
    ":nth-child(4n+1)_borderLeftStyle": null,
    ":nth-child(4n+1)_borderInlineStartStyle": null,
    ":nth-child(4n+1)_borderInlineEndStyle": null,
    ":nth-child(4n+1)_borderLeftColor": null,
    ":nth-child(4n+1)_borderInlineStartColor": null,
    ":nth-child(4n+1)_borderInlineEndColor": null,
    ":nth-child(4)_borderTopRightRadius": "evdzo6gw",
    ":nth-child(4)_borderStartStartRadius": null,
    ":nth-child(4)_borderStartEndRadius": null,
    ":nth-child(n + 9)_borderBottom": "ev1qmgjwk",
    ":nth-child(n + 9)_borderBottomWidth": null,
    ":nth-child(n + 9)_borderBottomStyle": null,
    ":nth-child(n + 9)_borderBottomColor": null,
    ":nth-child(9)_borderBottomLeftRadius": "ev1vhxsb0",
    ":nth-child(9)_borderEndStartRadius": null,
    ":nth-child(9)_borderEndEndRadius": null,
    ":nth-child(12)_borderBottomRightRadius": "ev1gy14w1",
    ":nth-child(12)_borderEndStartRadius": null,
    ":nth-child(12)_borderEndEndRadius": null,
    $$css: true
  },
  active: {
    "PickTimePopUp__ui.active": "PickTimePopUp__ui.active",
    backgroundColor: "evwnonoy",
    color: "ev1tzx33q",
    $$css: true
  },
  am_pm: {
    "PickTimePopUp__ui.am_pm": "PickTimePopUp__ui.am_pm",
    padding: "ev9ms5i6",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    cursor: "ev1ypdohk",
    color: "ev17e5z5g",
    border: "evtv0qo8",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "evjbqb8w ev1dfczft evfge0gx",
    fontSize: "ev4z9k3i",
    ":first-of-type_borderTopLeftRadius": "ev2kl6on",
    ":first-of-type_borderStartStartRadius": null,
    ":first-of-type_borderStartEndRadius": null,
    ":first-of-type_borderTopRightRadius": "ev15hiw4d",
    ":first-of-type_borderBottom": "ev1mrc810",
    ":first-of-type_borderBottomWidth": null,
    ":first-of-type_borderBottomStyle": null,
    ":first-of-type_borderBottomColor": null,
    ":last-of-type_borderBottomLeftRadius": "evus5cz4",
    ":last-of-type_borderEndStartRadius": null,
    ":last-of-type_borderEndEndRadius": null,
    ":last-of-type_borderBottomRightRadius": "ev16i8jsc",
    $$css: true
  }
};